import React from 'react'
import { StyledNewCheckbox } from './styled'
import { NewCheckboxProps } from './types'

export const NewCheckBox: React.FC<NewCheckboxProps> = (props: NewCheckboxProps) => {
  return <StyledNewCheckbox {...props} />
}
